var tag = document.createElement("script");

tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName("script")[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

var videos = [];
var youTubeInitializedPd = false;

function onYouTubeIframeAPIReady() {
  var numOfVideos = $(".x-videos .video").length;

  if (numOfVideos < 1) return;

  $(".x-videos .video").each(function(index) {
    if ($(this).hasClass("video")) {
        videos[index] = new YT.Player(
          $(this).attr("id"),
          {
            height: "540",
            width: "960",
            host: "https://www.youtube.com",
            videoId: $(this)
              .data("video-code"),
            playerVars: {
              rel: "0",
              controls: "0",
              showinfo: "0"
            }
          }
        );
        videos[index].providerType = "youtube";
        youTubeInitializedPd = true;
    }
  });
}

Vendd.Scripts.load(function() {

  $('.js-play-video', $(".x-videos")).click(function() {
    $(".x-videos .imageVideo").css("display","none")
    var index = $(this).data("index");
      videos[index].playVideo();
  });
});